import { configureStore } from '@reduxjs/toolkit';
import companyReducer from './components/company/companySlice';
import userReducer from './components/user/userSlice';
import vehicleReducer from './components/vehicle/vehicleSlice';
import assetReducer from './components/asset/assetSlice';
import navReducer from './components/nav/navSlice';
import signalrReducer from './api/signalrSlice';
import signalrMiddleware from './api/signalrMiddleware';

export default configureStore({
    reducer: {
        company: companyReducer,
        user: userReducer,
        vehicle: vehicleReducer,
        asset: assetReducer,
        nav: navReducer,
        signalr: signalrReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(signalrMiddleware),
})
